import { useState, useEffect, useCallback, memo } from "react";
import { motion, AnimatePresence } from "framer-motion";

const events = [
  { killer: "aeoneuh", victim: "noob_master", weapon: "AK-47", headshot: true },
  { killer: "aeoneuh", victim: "xD_pwner", weapon: "AWP", headshot: false },
  { killer: "aeoneuh", victim: "smoke_blind", weapon: "USP-S", headshot: true },
  { killer: "aeoneuh", victim: "eco_warrior", weapon: "Deagle", headshot: true },
  { killer: "aeoneuh", victim: "rush_b_no_stop", weapon: "M4A1-S", headshot: false },
  { killer: "aeoneuh", victim: "flash_self", weapon: "Glock-18", headshot: true },
];

function KillFeed() {
  const [feed, setFeed] = useState([]);

  const addKill = useCallback(() => {
    const event = events[Math.floor(Math.random() * events.length)];
    const id = Date.now();
    setFeed((prev) => [...prev.slice(-2), { ...event, id }]);
    const t = setTimeout(() => setFeed((prev) => prev.filter((k) => k.id !== id)), 3500);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const interval = setInterval(addKill, 10000);
    return () => clearInterval(interval);
  }, [addKill]);

  return (
    <div className="fixed top-16 right-4 md:right-6 z-50 space-y-1 pointer-events-none select-none">
      <AnimatePresence>
        {feed.map((k) => (
          <motion.div
            key={k.id}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            transition={{ duration: 0.2 }}
            className="flex items-center gap-1.5 bg-[#09090b]/80 border border-white/5 px-2.5 py-1 font-mono text-[9px]"
          >
            <span className="text-[#F47B20] font-bold">{k.killer}</span>
            <span className="text-white/20">[{k.weapon}]</span>
            <span className="text-white/40">{k.victim}</span>
            {k.headshot && <span className="text-[#F47B20] text-[7px]">HS</span>}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}

export default memo(KillFeed);
